import React, { Suspense, useEffect, useState } from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { withSnackbar } from 'notistack';
import { LinearProgress } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import { signOut } from '~/thunks';

import {
  getIsAuthorized,
  getIsSocketConnected,
  getIsSubApp,
} from '~/selectors';

import { connect as connectSocket } from '~/api/ws';

import styles from './styles';
import NavBar from './NavBar';
import TopBar from './TopBar';
import { useAppContext } from '~/application-context';

function Dashboard({ route, history, enqueueSnackbar }) {
  const classes = styles();

  const dispatch = useDispatch();
  const isSubApp = useSelector(getIsSubApp);
  const isAuthorized = useSelector(getIsAuthorized);
  const isSocketConnected = useSelector(getIsSocketConnected);

  const appContext = useAppContext();

  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);

  useEffect(() => {
    if (!isSocketConnected && (!isSubApp || (isSubApp && isAuthorized))) {
      connectSocket({
        enqueueSnackbar,
        apiBaseURL: appContext.apiBaseURL,
      }).catch(() => {
        dispatch(signOut());

        if (!isSubApp) {
          history.push('/auth/login');
        }
      });
    }
  }, [
    isSocketConnected,
    dispatch,
    enqueueSnackbar,
    history,
    isSubApp,
    isAuthorized,
    appContext.apiBaseURL,
  ]);

  return (
    <>
      <div>
        {!isSubApp && (
          <TopBar onOpenNavBarMobile={() => setOpenNavBarMobile(true)} />
        )}
        <NavBar
          onMobileClose={() => setOpenNavBarMobile(false)}
          openMobile={openNavBarMobile}
        />
      </div>
      <div className={classes.container}>
        <div className={isSubApp ? classes.contentIframe : classes.content}>
          <Suspense fallback={<LinearProgress />}>
            {isSocketConnected ? (
              renderRoutes(route.routes)
            ) : (
              <LinearProgress />
            )}
          </Suspense>
        </div>
      </div>
    </>
  );
}

Dashboard.propTypes = {
  route: PropTypes.shape({}),
};

Dashboard.defaultProps = {
  route: {},
};

export default withSnackbar(Dashboard);
